import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import InterviewDates from "./components/InterviewDates/InterviewDates";
import "./InterviewCard.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUpcomingInterviewsRequest,
  fetchJobCandidateId,
} from "../../store/actions";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { format } from "date-fns";
import AttendeesAvatar from "./components/Participants/AttendeesAvatar";

function InterviewCard({
  setJobTimeLineData,
  openCancelModal,
  openLogsModal,
  interviewComplete,
  handleSelectInterview,
  setReadOnly,
  toggleOffcanvas,
  direction,
  interviewDate,
  setInterviewDate,
  setActiveOffCanvas,
  refreshKey,
  getMaxOrder,
  setActiveStep,
  setOriginalOrder,
  setInterviewId,
  ...args
}) {
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(null);

  const toggleDropdown = (index) => {
    setDropdownOpen((prevState) => (prevState === index ? null : index));
  };

  const dailyInterviews = useSelector(
    (state) => state?.DailyInterviewsReducer?.dailyInterviews?.data?.interviews
  );
  const jobTimelineData = useSelector(
    (state) => state?.InterviewFormReducer?.jobTimelineData
  );

  const formattedInterviewDate = interviewDate.toLocaleDateString("en-CA");

  useEffect(() => {
    dispatch(fetchUpcomingInterviewsRequest(formattedInterviewDate));
  }, [interviewDate, refreshKey]);
  return (
    <Col md="6" className="d-flex">
      <Card className="shadow-sm rounded flex-grow-1">
        <CardBody className="p-4">
          <Row className="align-items-center mb-4">
            <Col>
              <CardTitle className="fw-bold">Upcoming Interviews</CardTitle>
            </Col>
            <Col className="d-flex justify-content-end">
              <InterviewDates
                setInterviewDate={setInterviewDate}
                interviewDate={interviewDate}
              />
            </Col>
          </Row>
          <SimpleBar style={{ maxHeight: "230px", overflowX: "hidden" }}>
            {dailyInterviews?.length > 0 ? (
              dailyInterviews
                .sort(
                  (a, b) =>
                    new Date(`1970-01-01T${a.fromTime}`) -
                    new Date(`1970-01-01T${b.fromTime}`)
                )
                .map(
                  (interview) =>
                    interview.status !== "CANCELLED" && (
                      <InterviewRow
                        setJobTimeLineData={setJobTimeLineData}
                        key={interview.id}
                        interview={interview}
                        toggle={toggleDropdown}
                        dropdownOpen={dropdownOpen}
                        direction={direction}
                        args={args}
                        toggleOffcanvas={toggleOffcanvas}
                        setReadOnly={setReadOnly}
                        interviewComplete={interviewComplete}
                        handleSelectInterview={handleSelectInterview}
                        setActiveOffCanvas={setActiveOffCanvas}
                        openCancelModal={openCancelModal}
                        openLogsModal={openLogsModal}
                        getMaxOrder={getMaxOrder}
                        setActiveStep={setActiveStep}
                        jobTimelineData={jobTimelineData}
                        setOriginalOrder={setOriginalOrder}
                        setInterviewId={setInterviewId}
                      />
                    )
                )
            ) : (
              <div>No interviews available</div>
            )}
          </SimpleBar>
        </CardBody>
      </Card>
    </Col>
  );
}

const InterviewRow = ({
  setJobTimeLineData,
  toggleOffcanvas,
  setActiveOffCanvas,
  openLogsModal,
  openCancelModal,
  handleSelectInterview,
  setReadOnly,
  interview,
  toggle,
  dropdownOpen,
  direction,
  getMaxOrder,
  setActiveStep,
  jobTimelineData,
  setOriginalOrder,
  setInterviewId,
  args,
}) => {
  const dispatch = useDispatch();
  const [isCompleted, setIsCompleted] = useState(false);
  const [attendees, setAttendees] = useState([]);

  useEffect(() => {
    setAttendees(
      interview.attendees.split(",").map((attendee) =>
        attendee
          .trim()
          .split(" ")
          .map((name) => name[0])
          .join("")
      )
    );
  }, [interview]);

  useEffect(() => {
    const interviewTime = new Date(
      `${interview.toDate}T${interview.toTime}`
    ).getTime();
    const currentTime = new Date().getTime();

    if (interviewTime < currentTime && interview.status !== "COMPLETED") {
      setIsCompleted(true);
    } else if (interview.status === "COMPLETED") {
      setIsCompleted(true);
    }
  }, [interview]);

  const handleRescheduleInterview = () => {
    dispatch(
      fetchJobCandidateId({
        jobId: interview.jobId,
        candidateId: interview.candidateId,
      })
    );
    setInterviewId(interview.id);
    // setJobTimeLineData(jobTimelineData);
    setActiveStep(15);
    setOriginalOrder(interview.stageOrder);
    setReadOnly(false);
    setActiveOffCanvas("reschedule_Interview");
    toggleOffcanvas();
  };

  const handleViewInterview = () => {
    // handleSelectInterview(interview);
    dispatch(
      fetchJobCandidateId({
        jobId: interview.jobId,
        candidateId: interview.candidateId,
      })
    );
    // setJobTimeLineData(jobTimelineData);
    setInterviewId(interview.id);
    setActiveStep(15);
    setOriginalOrder(interview.stageOrder);
    setReadOnly(true);
    setActiveOffCanvas("view_Interview");
    toggleOffcanvas();
  };

  const interviewCancel = () => {
    dispatch(
      fetchJobCandidateId({
        jobId: interview.jobId,
        candidateId: interview.candidateId,
      })
    );
    setActiveStep(16);
    setOriginalOrder(interview.stageOrder);
    openCancelModal(interview);
  };

  const interviewLogs = () => {
    dispatch(
      fetchJobCandidateId({
        jobId: interview.jobId,
        candidateId: interview.candidateId,
      })
    );
    setActiveStep(27);
    setOriginalOrder(interview.stageOrder);
    openLogsModal(interview);
  };

  useEffect(() => {
    if (jobTimelineData && jobTimelineData?.timeline) {
      setJobTimeLineData(jobTimelineData);
    }
  }, [jobTimelineData]);

  const formatTime = (time) => {
    const [hours, minutes, seconds] = time.split(":");
    return format(new Date(0, 0, 0, hours, minutes, seconds), "hh:mm a");
  };

  return (
    <Row
      className="align-items-center mb-3 me-3 rounded cursor-pointer"
      style={{ minHeight: "40px", backgroundColor: "#f8f9fa" }}
    >
      <Col
        className="custom-checkbox ms-2"
        xs="1"
        onClick={handleViewInterview}
      >
        {isCompleted ? (
          <i className="bi bi-check-circle-fill text-primary h2"></i>
        ) : (
          <i className="bi bi-check-circle text-muted h2"></i>
        )}
      </Col>
      <Col
        className="pt-0"
        xs="6"
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          textDecoration: isCompleted ? "line-through" : "none",
          color: isCompleted ? "#6c757d" : "inherit",
          cursor: "pointer",
          fontSize: "15px",
        }}
        onClick={handleViewInterview}
      >
        Sub:{" "}
        {interview.title.length > 10
          ? `${interview.title.slice(0, 10)}...`
          : interview.title}{" "}
        | Candidate ID: {interview.candidateName}
      </Col>
      <Col className="ps-0 pe-0 color-muted" onClick={handleViewInterview}>
        <AttendeesAvatar attendees={attendees} />
      </Col>
      <Col
        className="pe-0 align-content-end"
        xs="2"
        onClick={handleViewInterview}
      >
        <strong style={{ fontSize: "12px" }}>
          {interview.fromTime ? formatTime(interview.fromTime) : "-:--"}
        </strong>
      </Col>
      <Col className="pe-0 " xs="1">
        <Dropdown
          isOpen={dropdownOpen === interview.id}
          toggle={() => toggle(interview.id)}
          direction={direction}
        >
          <DropdownToggle
            caret={false}
            tag="span"
            className="text-muted"
            style={{ cursor: "pointer" }}
          >
            <i className="bi bi-three-dots" style={{ color: "#6c757d" }} />
          </DropdownToggle>
          <DropdownMenu {...args}>
            <DropdownItem onClick={interviewLogs}>
              Interview Feedback
            </DropdownItem>
            <DropdownItem onClick={handleRescheduleInterview}>
              Reschedule
            </DropdownItem>
            <DropdownItem onClick={interviewCancel}>
              Cancel Interview
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Col>
    </Row>
  );
};

export default InterviewCard;
